import click from './handlerClick.js';
import './assets/scss/toggler.orig.scss';

export default {
    view: 'icon',
    icon: 'fa fa-bars save__columns navbar-minimalize minimalize-styl-2 btn',
    click,
    container: 'main-menu-toggler-container',
};
